/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('variant:changed', function(event) {
    var variant = event.detail.variant; // Gives you access to the whole variant details
    var element = document.getElementById("variant_preorder_info_" + variant.id)
    var inventory_note = document.getElementsByClassName("ProductForm__Inventory")[0];
    var allDeliveryNotes = document.getElementsByClassName("Preorder_infotext");

    for (let note of allDeliveryNotes) {
        note.classList.add("hide-element");
    }
  
    if (element) {
      inventory_note.classList.add("hide-element");
      element.classList.remove("hide-element");
    } else {
      inventory_note.classList.remove("hide-element");
    }
  
 });